// assets/360-fix.js
(function(){
  'use strict';

  function swapDataAttrsToSrc(root) {
    root = root || document;
    var sel = 'img[data-src], img[data-srcset], img[data-lazy], img[data-lazy-src], img[data-lazysrc], img[data-src-large]';
    var imgs = Array.prototype.slice.call(root.querySelectorAll(sel));
    var count = 0;
    imgs.forEach(function(img){
      try {
        var ds = img.dataset || {};
        if (ds.src && (!img.src || img.src.indexOf('data:') === 0 || img.src === '')) { img.src = ds.src; count++; }
        if (ds.srcset && (!img.srcset || img.srcset.indexOf('data:') === 0 || img.srcset === '')) { img.srcset = ds.srcset; count++; }
        if (ds.lazySrc && (!img.src || img.src.indexOf('data:') === 0 || img.src === '')) { img.src = ds.lazySrc; count++; }
        img.classList.remove('lazyload','lazy','ls-is-cached');
      } catch(e){}
    });
    return count;
  }

  function refreshCarousels() {
    try {
      if (window.jQuery && typeof window.jQuery.fn.slick === 'function') {
        try { window.jQuery('.product-gallery, .product-gallery__slides, .js-product-gallery-replace').filter('.slick-initialized').slick('refresh'); } catch(e){}
      }
      if (window.Swiper && window.productSwiper && typeof window.productSwiper.update === 'function') { try { window.productSwiper.update(); } catch(e){} }
      document.querySelectorAll('.splide').forEach(function(el){ if (el.splide && typeof el.splide.refresh === 'function') try{ el.splide.refresh(); }catch(e){} });
      document.querySelectorAll('.flickity-enabled').forEach(function(el){ if (el._flickity && typeof el._flickity.resize === 'function') try{ el._flickity.resize(); }catch(e){} });
      window.dispatchEvent(new Event('resize'));
    } catch(e){}
  }

  function ensureGalleryLoad(root) {
    try {
      var rootEl = root || document.querySelector('.js-product-gallery-replace') || document;
      var changed = swapDataAttrsToSrc(rootEl);
      if (changed) setTimeout(refreshCarousels, 120);
      else setTimeout(refreshCarousels, 250);
      return changed;
    } catch(e){ return 0; }
  }

  // run as early as possible and after DOMContentLoaded
  try {
    ensureGalleryLoad();
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(function(){ ensureGalleryLoad(); }, 50); });
  } catch(e){}

  // observe dynamic changes (theme block rerenders)
  try {
    var observerTarget = document.body || document.documentElement;
    var mo = new MutationObserver(function(mutations){
      if (mo._t) clearTimeout(mo._t);
      mo._t = setTimeout(function(){
        try { ensureGalleryLoad(document.querySelector('.js-product-gallery-replace') || document); } catch(e){}
      }, 120);
    });
    mo.observe(observerTarget, { childList: true, subtree: true });
  } catch(e){}

  // manual trigger
  window.forceGalleryImageLoad = function(){
    try {
      ensureGalleryLoad(document.querySelector('.js-product-gallery-replace') || document);
      console.info('forceGalleryImageLoad executed');
    } catch(e){ console.warn(e); }
  };
})();
